export class BankDetailConstants {

public static TEXT_UNAUDITED = "Unaudited";
public static TEXT_MAINTITLE = "Receivership Balance Sheet Summary"
public static TEXT_DETAIL1 = "Fund Code"
public static TEXT_DETAIL2 = "Failure Date"
public static TEXT_SUBTITLE1A = "For Period Ending"
public static TEXT_SUBTITLE1B = "in $000's"
public static TEXT_SUBTITLE2 = "Claims Detail Summary"

public static FILLER = "\u00A0" 

//Assets
public static ASSET_CASH = "Cash and Investments"
public static ASSET_DUE = "Due from FDIC Corp and Receivables"
public static ASSET_LIQUID = "Assets in Liquidation"
public static ASSET_LOSS = "Estimated Loss on Assets in Liquidation"
public static ASSET_HEADER = ['Assets','Current Balance']
public static ASSET_TOTAL = "Total Assets"

//Liabilities
public static LIAB_ADMIN = "Administrative Liabilities"
public static LIAB_SUBROGATED = "FDIC Subrogated Deposit Claim "
public static LIAB_UNINSURED = "Uninsured Deposit Claims"
public static LIAB_OTHER = "Other Claimant Liabilities"
public static LIAB_UNPROVEN = "Unproven Claims"
public static LIAB_TOTALLIAB = "Total Liabilities"
public static LIAB_NET = "Net Worth (Deficit)"
public static LIAB_HEADER = ['Liabilities','Current Balance']
public static LIAB_TOTAL = "Total Liabilities and Net Worth"

//Other
public static OTHER_GENERAL = "General Creditor"
public static OTHER_SENIOR = "Senior Debt Holders"
public static OTHER_SUBDEBT = "Subordinated Debt Holders"
public static OTHER_SUBTOTAL = "SubTotal - Other Claimants"
public static OTHER_LESS = "Less: Dividends Paid to Date"
public static OTHER_HEADER = ["Other Claimants","Claim Balance","%"]
public static OTHER_TOTAL = "Total Unpaid Other Claimants"

//Proven
public static PROVEN_SUBROGATED = "FDIC Subrogated Claim"
public static PROVEN_UNINSURED = "Uninsured Depositors"
public static PROVEN_SUBTOTAL = "SubTotal - Proven Deposit Claims"
public static PROVEN_LESS = "Less: Dividends Paid to Date"
public static PROVEN_HEADER = ["Proven Deposit Claims","Claim Balance","%"]
public static PROVEN_TOTAL = "Total Unpaid Deposit Claims"

// Quarter Dates
public static BANK_QUARTER_1 = "March 31";
public static BANK_QUARTER_2 = "June 30";
public static BANK_QUARTER_3 = "September 30";
public static BANK_QUARTER_4 = "December 31";
}